import Carriers from './Carriers.vue'

export default Carriers
